import { render, staticRenderFns } from "./ReviewStageStatusBadge.vue?vue&type=template&id=687a7238&"
import script from "./ReviewStageStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ReviewStageStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStageStatusBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports